module.exports = __webpack_public_path__ + "static/media/a(4).34714e6c.png";